import { Injectable } from '@angular/core';
import { LyTheme } from './theme.service';
export function getContrastYIQ(hexcolor) {
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
}
export function getColor(colors, color, shade) {
    if (colors[color]) {
        var shadeColor = colors[color].color;
        if (typeof shadeColor === 'string') {
            return colors[color].color;
        }
        else {
            return colors[color].color[shade];
        }
    }
    else {
        if (typeof color === 'string') {
            return color;
        }
        else {
            return color[shade];
        }
    }
}
var BgAndColorStyle = /** @class */ (function () {
    function BgAndColorStyle() {
    }
    return BgAndColorStyle;
}());
export { BgAndColorStyle };
var LyStyleTheme = /** @class */ (function () {
    function LyStyleTheme(theme) {
        this.theme = theme;
    }
    LyStyleTheme.decorators = [
        { type: Injectable },
    ];
    /**
       * for bg or color inputs, find the color in palette, return color
       * example: this.theme.update('bg', 'primary', this.theme.AlyleUI.palette); // #00bcd4
       */
    // getPalette(color: string, colors?: any): string {
    //   let result: string;
    //   if (colors) {
    //     result = getColor(colors, color);
    //   } else {
    //     result = getColor(this.theme.AlyleUI.palette, color);
    //   }
    //   return result;
    // }
    /** @nocollapse */
    LyStyleTheme.ctorParameters = function () { return [
        { type: LyTheme, },
    ]; };
    return LyStyleTheme;
}());
export { LyStyleTheme };
/**
 * -------------
 */
var LyPalette = /** @class */ (function () {
    function LyPalette() {
        this._primary = {
            name: 'none',
            color: '#fff',
            text: '#fff',
        };
        this._accent = {
            name: 'none',
            color: '#fff',
            text: '#fff',
        };
        this._other = {
            name: 'none',
            color: '#fff',
            text: '#fff',
        };
        this.themeApp = {
            light: {
                color: '#24292e',
                background: '#f5f5f5',
            },
            dark: {
                color: '#f5f5f5',
                background: '#2C2D31',
            },
        };
        this.text = {
            default: 'rgba(0, 0, 0, 0.75)',
            light: '#fff',
            dark: '#2C2D31',
        };
    }
    LyPalette.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LyPalette.ctorParameters = function () { return []; };
    return LyPalette;
}());
export { LyPalette };
//# sourceMappingURL=palette.js.map